module.exports = __webpack_public_path__ + "img/杜仲.5684d08f.jpg";